import React, {Component} from 'react';
import ReportGeneralTable from '../report/ReportGeneralTable'
// import ReportStore from '../../stores/ReportStore'
import StockStore from '../../stores/StockStore'
import FontAwesome from 'react-fontawesome';
// import { Popover, OverlayTrigger } from 'react-bootstrap';
import StockAnyExportDoc from './StockAnyExportDoc';
import {connect} from 'react-redux'
import Select from 'react-select'
class StockAnyExportReport extends Component {

  
  constructor(...args){
    super(...args)
    this.state = {showTable:true,mpNo:'',doc:''}
    this.qoTable = null
  }

  // renameDoc(newPoNo){
  //   this.refs.soDoc.renameDoc(newPoNo)
  // }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.setState({showTable:true})
    }
  }

  showTable(){
    this.setState({showTable:true})
    if(this.qoTable!==null)
      this.qoTable.refreshTable()  
    if(this.props.onTableShow!==undefined){
      this.props.onTableShow()
    }
  }

  onRowSelect(item){
    this.setState({showTable:false,mpNo:item.recordid,doc:item})
  }

  onDocNew(){
    this.setState({showTable:false,doc:{recordid:''}})     
  }

  onDocClose(){
    this.showTable() 
  }

  loadData(year,month,day,searchBy,query,activePage,itemPerPage,callback){
    let {type} = this.props
    StockStore.loadStockTransaction_('any',year-543,month,day,searchBy,(type==='pickup'?'export':'import'),activePage*itemPerPage,itemPerPage,query,'',callback)
  }

  getDate(added_date,type) {
    let date = added_date
    if (type=='day')
      date = date.substring(0, 10)
    else
      date = date.substring(11, 19)

    return date
  }

  renderItems(items) {
    let {messages} = this.props
    if (items.length===0||items===undefined) {
      return ('')
    } else {
      return(
        items.map((item,index)=> {
          return(
            <div key={index}>
              <p>{' - ' + item.description + ' '+messages['Quantity']+' ' + item.quantity+' '+(item.unit!==''&&item.unit!==undefined&&item.unit!==null?item.unit:'รายการ')}</p>
            </div>
          )
        })
      )
    }
  }

  onPrintClick(rid){
    if (process.env.NODE_ENV === "development") {
      window.open('https://demo2.bigfix.co/korat/pdf/?sr='+rid+'&file=stockrecord_doc', '_blank');
    } else{
      window.open('./pdf/?sr='+rid+'&file=stockrecord_doc', '_blank');
    }
  }

  // onRenderColumn(data,col,row){
  //   let {messages} = this.props
  //   if (col===1||col===2) {
  //     let type = 'day'
  //     if (col===2)
  //       type = 'time'
  //     return(<span>{this.getDate(row.added_date,type)}</span>)
  //   } else if (col===3) {
  //     return(<span>{row.record_type=='export'?messages['Export']:messages['Import']}</span>)
  //   } else if (col===4) {
  //     return(<span>{row.request_by}</span>)
  //   } else if (col===5) {
  //     return(<span>{row.response_by}</span>)
  //   } else if (col===6) {
  //     return(<span>{row.car_registration_no}</span>)
  //   } else if (col===7) {
  //     return(<span>{this.renderItems(row.items)}</span>)
  //   } else if (col===9) {
  //     return(<span>{row.description}</span>)
  //   } else if (col===10) {
  //     return (<span><button onClick={this.onPrintClick.bind(this,row.recordid)} className='btn btn-default'><FontAwesome name='print' /></button></span>)
  //   }
  // }

  onPRStatusChange(recordid,e) {
    StockStore.updatePRStatus(recordid,e.value,(result)=>{
      if (result.status==='OK') {
        if (this.qoTable!==null)
          this.qoTable.refreshTable()  
      }
    })
  }

  onRenderColumn(data,col,row,index,sub_index){
    let {messages} = this.props
    if (sub_index===0||sub_index===1) {
      let type = 'day'
      if (sub_index===1)
        type = 'time'
      return(<span>{this.getDate(row.added_date,type)}</span>)
    } else if (sub_index===2) {
      return(<span>{row.record_type=='export'?messages['Export']:messages['Import']}</span>)
    } else if (sub_index===3) {
      return(<span>{row.request_by}</span>)
    } else if (sub_index===4) {
      return(<span>{row.response_by}</span>)
    } else if (sub_index===5) {
      return(<span>{row.shop_name}</span>)
    } else if (sub_index===6) {
      return(<span>{this.renderItems(row.items)}</span>)
    } else if (sub_index===7) {
      return(<span>{row.description}</span>)
    // } else if (sub_index===8) {
    //   return(
    //     <Select
    //       style={{background:(row.pr_status==='1'?'#5cb85c':row.pr_status==='2'?'#d9534f':'')}}
    //       options={[{label:'รออนุมัติ',value:'0'},{label:'อนุมัติ',value:'1'},{label:'ไม่อนุมัติ',value:'2'}]}
    //       value={row.pr_status}
    //       onChange={this.onPRStatusChange.bind(this,row.recordid)}
    //       clearable={false}
    //     />
    //   )
    // }
    } else if (sub_index===8) {
      return (<span><button onClick={this.onPrintClick.bind(this,row.recordid)} className='btn btn-default'><FontAwesome name='print' /></button></span>)
    }
  }

  render(){
    let {doc,showTable} = this.state
    let {type,messages} = this.props
    const headerTitles = [
      {title:messages['Day'],width:'150px'},
      {title:messages['Time'],width:'100px'},
      {title:messages['Type'],width:'150px'},
      {title:messages['Requester'],width:'170px'},
      {title:messages['Approvers'],width:'170px'},      
      {title:messages['Car Registration'],width:'150px'},
      {title:messages['List'],width:'350px'},
      {title:messages['Description'],width:'350px'},
      // {title:messages['Approved'],width:'150px'},
      {title:'',width:'50px'}             
    ]
    const searchOptions = [
      {
        label: messages['Car Registration'],
        value: 'car_registration_no'
      },
      {
        label: type==='pickup'?messages['Requester']:messages['Requester'],
        value: 'request_by'
      },
      {
        label: messages['Approvers'],
        value: 'response_by'
      },      
    ]
    return (
      <div>
        <div style={{display:showTable?'':'none'}}>
          <ReportGeneralTable 
          onRef={(ref)=>{this.qoTable = ref}}
          loadOnShow={this.props.loadOnShow!==undefined?this.props.loadOnShow:this.props.show}
          show={this.props.show}
          title={type==='pickup'?messages['Picking up']:messages['Recieved']}
          txtTable={false}
          newTitle={type==='pickup'?messages['Add Picking up Item']:messages['Add Recieved Item']}
          showPrintButton={false}
          showNewButton={true}
          headerTitles={headerTitles}
          // excludeColumn={['recordid','shop_name','ref_po_no']}
          bodyColumn={['added_date','added_date','record_type','request_by','response_by','car_registration_no','items','description','ref_po_no']}
          excludeClickColumn={['recordid']}
          searchOptions={searchOptions}          
          searchBy={'car_registration_no'}
          loadData={this.loadData.bind(this)}
          onRenderColumn={this.onRenderColumn.bind(this)}
          onDocNew={this.onDocNew.bind(this)}
          isMobile={this.props.isMobile}
          mobileFieldMap={{title:'request_by',amount:'response_by',sub_title:{isArray:true,sub_title:'items',field:'description'},date:'',status:'',sub_status:''}}
          numberFormat={false}
          dataCount='total_count'
          callOut={this.props.callOut}
          />
        </div>
        <div >
          <StockAnyExportDoc 
            show={!showTable}
            doc={doc} 
            onClose={this.onDocClose.bind(this)}
            title={type==='pickup'?messages['Picking up List']:messages['Recieved List']}
            type={type}
          />
        </div>
      </div>
    )
  }
}

StockAnyExportReport.defaultProps = {
  show:false,
  type:'pickup',
  callOut:false,
  loadOnShow:undefined,
}
export default connect(
  (state) => ({messages: state.message.view.stock.StockAnyExportReport}),null,null,{withRef:true},
)(StockAnyExportReport);





// WEBPACK FOOTER //
// ./src/view/stock/StockAnyExportReport.js